var CustomNameSpace = CustomNameSpace || {};

CustomNameSpace.helpers = {

	// Calculate pagination range
	paginationRange: function(paginator_limit, total_pages, current_page, last_page) {
		var range = [];
		var half_of_limit = parseInt(paginator_limit/2);
		var i = 0;
		// Total amount of pages greater than pagination limit
		if(total_pages > paginator_limit) {

			// First pages (page 1 to limit)
			if(current_page-parseInt(half_of_limit) < 1) {
				for(i = 1; i<=paginator_limit; i++) {
					range.push(i);
				}
			}
			// Somewhere in the middle
			else if(current_page > half_of_limit && current_page+half_of_limit <= last_page ) {
				for(i = current_page-half_of_limit; i < current_page+half_of_limit; i++) {
					range.push(i);
				}
			}
			// Last pages (x page to last page)
			else if(current_page+half_of_limit > last_page) {
				for(i = last_page-paginator_limit+1; i<= last_page; i++) {
					range.push(i);	
				}
			}
		}
		// Total amount of pages smaller than paginator limit
		else {
			for(i = 1; i<= last_page; i++) {
				range.push(i);
			}
		}
		return range;
	},

	// Parse float with two decimal places
	formatPrice: function(price) {
		if (typeof price === 'undefined') {
			return '-';
		} 
		return parseFloat(price).toFixed(2);
	}

}